/**
 * Copyright © WarmHeart Intelligence Technology Group (Jiangsu) Co.,Ltd Company, Limited.
 * All Rights Reserved
 */
import url from "./conf";
import {post, tokenPost} from "./ajax";

const priceManage = {
  /**
   *  AJAX-分页获取采购调价单列表
   * @param info
   * @param page
   * @param success
   * @param fail
   * @param isLoadingExplicit
   * @param errorHandler
   */
  listPurchasePriceManageOrder(info,page, success, fail, isLoadingExplicit, errorHandler) {
    post.bind(this)(
      url.LIST_PURCHASE_PRICE_MANAGE_ORDER,
      {
        begin: info.startDate,
        end: info.endDate,
        num: info.id,
        supplierId: info.supplierId,
        materialId: info.materialId,
        staffId: info.staffId,
        pageIndex: page.pagination,
        pageSize: page.size,
      },
      success,
      fail,
      isLoadingExplicit,
      errorHandler
    );
  },
  /**
   *  AJAX-添加采购调价单
   * @param supplierId
   * @param remarks
   * @param items
   * @param success
   * @param fail
   * @param isLoadingExplicit
   * @param errorHandler
   */
  addPurchasePriceManage(supplierId,remarks,items,isEffect,effectTime, success, fail, isLoadingExplicit, errorHandler) {
    post.bind(this)(
      url.ADD_PURCHASE_PRICE_MANAGE,
      {
        supplierId: supplierId,
        remarks: remarks,
        items: items,
        effectTime: effectTime,
        isEffect: isEffect,
      },
      success,
      fail,
      isLoadingExplicit,
      errorHandler
    );
  },
  /**
   *  AJAX-获取采购调价单详情
   * @param num
   * @param success
   * @param fail
   * @param isLoadingExplicit
   * @param errorHandler
   */
  acquirePurchasePriceManageInfo(num, success, fail, isLoadingExplicit, errorHandler) {
    post.bind(this)(
      url.ACQUIRE_PURCHASE_PRICE_MANAGE_INFO,
      {
        num: num,
      },
      success,
      fail,
      isLoadingExplicit,
      errorHandler
    );
  },
  /**
   *  AJAX-作废采购调价单
   * @param num
   * @param success
   * @param fail
   * @param isLoadingExplicit
   * @param errorHandler
   */
  cancelPurchasePriceManage(num, success, fail, isLoadingExplicit, errorHandler) {
    post.bind(this)(
      url.CANCEL_PURCHASE_PRICE_MANAGE,
      {
        num: num,
      },
      success,
      fail,
      isLoadingExplicit,
      errorHandler
    );
  },
  /**
   *  AJAX-分页获取成本调价单列表
   * @param info
   * @param page
   * @param success
   * @param fail
   * @param isLoadingExplicit
   * @param errorHandler
   */
  listProducePriceManageOrder(info,page, success, fail, isLoadingExplicit, errorHandler) {
    post.bind(this)(
      url.LIST_PRODUCE_PRICE_MANAGE_ORDER,
      {
        begin: info.startDate,
        end: info.endDate,
        num: info.id,
        dcId: info.dcId,
        materialId: info.materialId,
        staffId: info.staffId,
        pageIndex: page.pagination,
        pageSize: page.size,
      },
      success,
      fail,
      isLoadingExplicit,
      errorHandler
    );
  },
  /**
   *  AJAX-添加成本调价单
   * @param dcId
   * @param remarks
   * @param items
   * @param success
   * @param fail
   * @param isLoadingExplicit
   * @param errorHandler
   */
  addProducePriceManage(dcId,remarks,items, success, fail, isLoadingExplicit, errorHandler) {
    post.bind(this)(
      url.ADD_PRODUCE_PRICE_MANAGE,
      {
        dcId: dcId,
        remarks: remarks,
        items: items
      },
      success,
      fail,
      isLoadingExplicit,
      errorHandler
    );
  },
  /**
   *  AJAX-获取成本调价单详情
   * @param num
   * @param success
   * @param fail
   * @param isLoadingExplicit
   * @param errorHandler
   */
  acquireProducePriceManageInfo(num, success, fail, isLoadingExplicit, errorHandler) {
    post.bind(this)(
      url.ACQUIRE_PRODUCE_PRICE_MANAGE_INFO,
      {
        num: num,
      },
      success,
      fail,
      isLoadingExplicit,
      errorHandler
    );
  },
  /**
   *  AJAX-获取配送中心下所有产成品
   * @param dcId
   * @param success
   * @param fail
   * @param isLoadingExplicit
   * @param errorHandler
   */
  listProduceMaterial(dcId, success, fail, isLoadingExplicit, errorHandler) {
    post.bind(this)(
      url.LIST_PRODUCE_MATERIAL_PRICE_MANAGE,
      {
        dcId: dcId,
      },
      success,
      fail,
      isLoadingExplicit,
      errorHandler
    );
  },
  /**
   *  AJAX-分页获取调拨调价单列表
   * @param info
   * @param page
   * @param success
   * @param fail
   * @param isLoadingExplicit
   * @param errorHandler
   */
  listAllotPriceManageOrder(info,page, success, fail, isLoadingExplicit, errorHandler) {
    post.bind(this)(
      url.LIST_ALLOT_PRICE_MANAGE_ORDER,
      {
        begin: info.startDate,
        end: info.endDate,
        num: info.id,
        dcId: info.dcId,
        materialId: info.materialId,
        staffId: info.staffId,
        orderStatus: info.statusId,
        pageIndex: page.pagination,
        pageSize: page.size,
      },
      success,
      fail,
      isLoadingExplicit,
      errorHandler
    );
  },
  /**
   *  AJAX-添加调拨调价单
   * @param dcId
   * @param effectTime
   * @param isEffect
   * @param remarks
   * @param items
   * @param success
   * @param fail
   * @param isLoadingExplicit
   * @param errorHandler
   */
  addAllotPriceManage(dcId,isEffect,effectTime,remarks,items, success, fail, isLoadingExplicit, errorHandler) {
    post.bind(this)(
      url.ADD_ALLOT_PRICE_MANAGE,
      {
        dcId: dcId,
        effectTime: effectTime,
        isEffect: isEffect,
        remarks: remarks,
        items: items
      },
      success,
      fail,
      isLoadingExplicit,
      errorHandler
    );
  },
  /**
   *  AJAX-获取调拨调价单详情
   * @param num
   * @param success
   * @param fail
   * @param isLoadingExplicit
   * @param errorHandler
   */
  acquireAllotPriceManageInfo(num, success, fail, isLoadingExplicit, errorHandler) {
    post.bind(this)(
      url.ACQUIRE_ALLOT_PRICE_MANAGE_INFO,
      {
        num: num,
      },
      success,
      fail,
      isLoadingExplicit,
      errorHandler
    );
  },
  /**
   *  AJAX-获取调拨货品
   * @param dcId
   * @param success
   * @param fail
   * @param isLoadingExplicit
   * @param errorHandler
   */
  listAllotMaterial(dcId, success, fail, isLoadingExplicit, errorHandler) {
    post.bind(this)(
      url.LIST_ALLOT_MATERIAL_PRICE_MANAGE,
      {
        dcId: dcId,
      },
      success,
      fail,
      isLoadingExplicit,
      errorHandler
    );
  },
  /**
   *  AJAX-作废调拨调价单
   * @param num
   * @param success
   * @param fail
   * @param isLoadingExplicit
   * @param errorHandler
   */
  cancelAllotPriceManage(num, success, fail, isLoadingExplicit, errorHandler) {
    post.bind(this)(
      url.CANCEL_ALLOT_PRICE_MANAGE,
      {
        num: num,
      },
      success,
      fail,
      isLoadingExplicit,
      errorHandler
    );
  },
  /**
   *  AJAX-根据门店和配送中心搜索货品
   * @param keys
   * @param dcId
   * @param shopIds
   * @param success
   * @param fail
   * @param isLoadingExplicit
   * @param errorHandler
   */
  searchRequireMaterials(keys,dcId,shopIds, success, fail, isLoadingExplicit, errorHandler) {
    post.bind(this)(
      url.SEARCH_REQUIRE_MATERIALS,
      {
        dcId: dcId,
        keys: keys,
        shopIds: shopIds,
      },
      success,
      fail,
      isLoadingExplicit,
      errorHandler
    );
  },
  /**
   *  AJAX-分页获取要货调价单列表
   * @param info
   * @param page
   * @param success
   * @param fail
   * @param isLoadingExplicit
   * @param errorHandler
   */
  listRequirePriceManage(info,page, success, fail, isLoadingExplicit, errorHandler) {
    post.bind(this)(
      url.LIST_REQUIRE_PRICE_MANAGE,
      {
        begin: info.startDate,
        end: info.endDate,
        num: info.id,
        dcId: info.dcId,
        materialId: info.materialId,
        staffId: info.staffId,
        orderStatus: info.statusId,
        shopId: info.shopId,
        pageIndex: page.pagination,
        pageSize: page.size,
      },
      success,
      fail,
      isLoadingExplicit,
      errorHandler
    );
  },
  /**
   *  AJAX-添加要货调价单
   * @param dcId
   * @param effectTime
   * @param isEffect
   * @param remarks
   * @param items
   * @param shopIds
   * @param success
   * @param fail
   * @param isLoadingExplicit
   * @param errorHandler
   */
  addRequirePriceManage(dcId,isEffect,effectTime,remarks,items,shopIds, success, fail, isLoadingExplicit, errorHandler) {
    post.bind(this)(
      url.ADD_REQUIRE_PRICE_MANAGE,
      {
        dcId: dcId,
        effectTime: effectTime,
        isEffect: isEffect,
        remarks: remarks,
        items: items,
        shopIds: shopIds,
      },
      success,
      fail,
      isLoadingExplicit,
      errorHandler
    );
  },
  /**
   *  AJAX-获取要货调价单详情
   * @param num
   * @param success
   * @param fail
   * @param isLoadingExplicit
   * @param errorHandler
   */
  acquireRequirePriceManage(num, success, fail, isLoadingExplicit, errorHandler) {
    post.bind(this)(
      url.ACQUIRE_REQUIRE_PRICE_MANAGE,
      {
        num: num,
      },
      success,
      fail,
      isLoadingExplicit,
      errorHandler
    );
  },
  /**
   *  AJAX-作废要货调价单
   * @param num
   * @param success
   * @param fail
   * @param isLoadingExplicit
   * @param errorHandler
   */
  cancelRequirePriceManage(num, success, fail, isLoadingExplicit, errorHandler) {
    post.bind(this)(
      url.CANCEL_REQUIRE_PRICE_MANAGE,
      {
        num: num,
      },
      success,
      fail,
      isLoadingExplicit,
      errorHandler
    );
  },
}

export default priceManage;



// WEBPACK FOOTER //
// ./src/assets/ajax/ajax-price-manage.js